export function installTableFormatting() {
  /* Tag table columns so headers align with their data and button columns hug the right edge. */
  (function () {
    const NUM = /^[\s(−-]*(₱|\d)[\d,.\s%)₱]*$/;
    function tidy() {
      document.querySelectorAll("table").forEach((t) => {
        const head = t.tHead && t.tHead.rows[0];
        if (!head) return;
        const rows = [...t.tBodies]
          .flatMap((b) => [...b.rows])
          .filter(
            (r) =>
              !r.classList.contains("grp") &&
              r.cells.length === head.cells.length,
          );
        if (!rows.length) return;
        [...head.cells].forEach((th, i) => {
          const cells = rows
            .map((r) => r.cells[i])
            .filter(
              (c) => c && (c.textContent.trim() || c.querySelector("button")),
            );
          if (!cells.length) return;
          const btn = cells.every(
            (c) =>
              c.querySelector("button") &&
              !c.textContent
                .replace(/\s+/g, " ")
                .trim()
                .replace(/[A-Za-z&]+(\s[A-Za-z&]+)*/g, "")
                .trim(),
          );
          const onlyBtn = cells.every(
            (c) =>
              [...c.querySelectorAll("button")].length &&
              [...c.children].every(
                (k) =>
                  k.tagName === "BUTTON" ||
                  k.classList.contains("row") ||
                  k.tagName === "DIV" ||
                  (k.tagName === "SPAN" && k.classList.contains("small")),
              ),
          );
          const num = cells.every(
            (c) => c.classList.contains("n") || NUM.test(c.textContent.trim()),
          );
          const act = btn || onlyBtn;
          th.classList.toggle("act", act);
          cells.forEach((c) => c.classList.toggle("act", act));
          if (!act && num) {
            th.classList.add("n");
            cells.forEach((c) => c.classList.add("n"));
          }
          // Short values (dates, codes, statuses) stay on one line; long text columns get room to wrap.
          const lens = cells.map((c) => c.textContent.trim().length),
            short = !act && !num && Math.max(...lens) <= 22;
          th.classList.toggle("nw", short);
          cells.forEach((c) => c.classList.toggle("nw", short));
          const long = !act && !num && !short && Math.max(...lens) >= 48;
          cells.forEach((c) => c.classList.toggle("wide", long));
          th.classList.toggle("wide", long);
        });
      });
    }
    const root = document.getElementById("root");
    let q = 0;
    new MutationObserver(() => {
      cancelAnimationFrame(q);
      q = requestAnimationFrame(tidy);
    }).observe(root, { childList: true, subtree: true });
    tidy();
  })();
}
